<template>
<!-- 出库记录查询 -->
	<div class="content_main">
		<div style="margin-top: 10px">
			<a-button type="primary" @click="exp"> 数据导出</a-button>
		</div>
		<div class="content_main_top">
			<a-select v-model="serchInfo.item_type" allowClear class="a_input_self margin_self" placeholder="物品类型"
				@keyup.enter.native="handleSubmitSerch">
				<a-select-option :value="1"> 固定资产 </a-select-option>
				<a-select-option :value="2"> 流动资产 </a-select-option>
			</a-select>
		
			<a-select v-model="serchInfo.company_id" allowClear class="a_input_self margin_self" placeholder="公司名称" @change="changeDept"
				@keyup.enter.native="handleSubmitSerch">
				<a-select-option :value="item.deptId" v-for="(item, index) in companyList" :key="index"> 
					{{ item.title }}
				</a-select-option>
			</a-select>
			<a-select show-search allowClear placeholder="部门名称" class="margin_self" :disabled="!this.serchInfo.company_id" 
						v-model="serchInfo.dept_id" @keyup.enter.native="query" style="width: 120px">
				<a-select-option :value="item.deptId" v-for="(item, index) in deptList" :key="index">
					{{ item.title }}
				</a-select-option>
			</a-select>

			<!-- <a-tree-select class="a_input_self margin_self" allowClear :treeData="deptTree" placeholder="领用部门" :disabled="!this.serchInfo.company_id" 
			v-model="serchInfo.dept_id">
			</a-tree-select> -->
			<a-input type="text" class="a_input_self margin_self" placeholder="领用人" allowClear v-model="serchInfo.applier"
				@keyup.enter.native="handleSubmitSerch" />
			<a-select v-model="serchInfo.trans_type" allowClear class="a_input_self margin_self" placeholder="出库类型"
				@keyup.enter.native="handleSubmitSerch">
				<a-select-option :value="Number(index)" v-for="(item, index) in types" :key="index"> {{ item }}
				</a-select-option>
			</a-select>
			<a-input type="text" class="a_input_self margin_self" placeholder="物品编号" allowClear
				v-model="serchInfo.spu_sn" @keyup.enter.native="handleSubmitSerch" />
			<a-input type="text" class="a_input_self margin_self" placeholder="物品名称" allowClear v-model="serchInfo.name"
				@keyup.enter.native="handleSubmitSerch" />
			<!-- <a-select v-model="serchInfo.item_type" allowClear class="a_input_self margin_self" placeholder="类别"
				@keyup.enter.native="handleSubmitSerch">
				<a-select-option :value="1"> 资产 </a-select-option>
				<a-select-option :value="2"> 耗材 </a-select-option>
			</a-select> -->
			<!-- <a-range-picker valueFormat="YYYY-MM-DD" style="margin-right: 10px; width: 220px" allowClear v-model="serchInfo.time"
			 :placeholder="['开始日期', '结束日期']" /> -->
			<a-button type="primary" @click="handleSubmitSerch()"> 搜索 </a-button>
			<a-button type="primary" ghost @click="rester()"> 重置 </a-button>
			<!-- <a-button v-if="assetsExportConsumables" type="primary" @click="exp"> 数据导出 </a-button> -->
		</div>
		<div class="content_main_center_scroll" id="content_main_center_scroll">
			<a-table :data-source="data" bordered :pagination="pagination" :loading="loading"
				@change="handleTableChange" :scroll="{ y: scroll_y }">
				<a-table-column key="index" title="序号" data-index="index" width="70px">
					<template scope="text, record, index">
						{{ (pagination.current - 1) * pagination.pageSize + index + 1 }}
					</template>
				</a-table-column>
				<a-table-column key="companyName" ellipsis="true" title="公司名称" data-index="companyName" />
				<a-table-column key="itemType" title="物品类型" ellipsis="true" data-index="itemType" >
					<template scope="text,record">
						<span>{{ record.itemType == 1? '固定资产': '流动资产' }}</span>
					</template>
				</a-table-column>
				<a-table-column key="itemSn" ellipsis="true" title="物品编号" data-index="itemSn" />
				<a-table-column key="name" ellipsis="true" title="物品名称" data-index="name" />
				<a-table-column key="model" ellipsis="true" title="规格型号" data-index="model" />
				<a-table-column key="spuAmount" ellipsis="true" title="原有库存" data-index="spuAmount" />
				<a-table-column key="amount" title="出库数量" data-index="amount" />
					<!-- <template scope="text,record">
						<span>{{ record.spuAmount == 1? '资产': '耗材' }}</span>
					</template>
				</a-table-column> -->
				
				<a-table-column key="unit" ellipsis="true" title="单位" data-index="unit" />
				
				<a-table-column key="deptName" ellipsis="true" title="领用部门" data-index="deptName" />
				<a-table-column key="applier" ellipsis="true" title="领用人" data-index="applier" />
				<a-table-column key="transType" title="出库类型" data-index="transType">
					<template scope="text,record">
						<span :style="{ color: colors1[record.transType] }">{{ types[record.transType] }}</span>
					</template>
				</a-table-column>
				<a-table-column key="operator" ellipsis="true" title="出库人" data-index="operator" />
				<a-table-column key="createTime" ellipsis="true" title="出库时间" data-index="createTime" />
				<a-table-column key="action" title="操作" data-index="action" width="100">
					<template scope="text,record">
						<a @click="details(record)">详情</a>
					</template>
				</a-table-column>
			</a-table>
		</div>
		<a-modal title="出库记录-详情" :visible="visible" @ok="visible=false" @cancel="visible=false" width="880px">
			<template slot="footer">
				<a-button key="back" @click="visible = false"> 取消 </a-button>
			</template>
			<a-form-model :model="detailsrow" :labelCol="labelCol" :wrapperCol="wrapperCol"
				v-if="detailsrow.itemType==1">
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="归属公司">
							<span>{{detailsrow.companyName}}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="物品类型">
							<span>{{detailsrow.itemType == 1? '固定资产':'流动资产'}}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="出库类型">
							<span>{{detailsrow.transTypeName}}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="资产类别">
							<span>{{detailsrow.assetTypeName}}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="物品编号">
							<span>{{detailsrow.assetSn}}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="物品名称">
							<span>{{detailsrow.name}}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="物品状态">
							<span>{{detailsrow.stateName}}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="规格型号">
							<span>{{detailsrow.model}}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="采购时间">
							<span>{{detailsrow.purchaseTime}}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="采购价格">
							<span>{{detailsrow.purchasePrice}}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="所属部门">
							<span>{{detailsrow.deptName}}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="当前估值">
							<span>{{detailsrow.value}}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="责任人">
							<span>{{detailsrow.charger}}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="保管人">
							<span>{{detailsrow.keeper}}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="到货日期">
							<span>{{detailsrow.arriveTime}}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="存放位置">
							<span>{{detailsrow.storageLoc}}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="作业条件">
							<span>{{detailsrow.storageCond}}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="供应商">
							<span>{{detailsrow.dealer}}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="生产厂家">
							<span>{{detailsrow.manufacturer}}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="出厂编号">
							<span>{{detailsrow.factorySn}}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="是否已检定">
							<span>{{instrumentMap[detailsrow.isInspected]}}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="检定周期">
							<span>{{detailsrow.inspectCycle}}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="检定日期">
							<span>{{detailsrow.inspectTime}}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="仪器精度">
							<span>{{detailsrow.precisions}}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="检定结果">
							<span>{{detailsrow.inspectResult}}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="准用说明">
							<span>{{detailsrow.permit}}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="原有库存">
							<span>{{detailsrow.spuAmount}}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="出库数量">
							<span>{{detailsrow.amount}}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="物品单位">
							<span>{{detailsrow.unit}}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="出库人">
							<span>{{detailsrow.operator}}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>

					<a-col :span="12">
						<a-form-model-item label="出库时间">
							<span>{{detailsrow.createTime}}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="备注信息">
							<span>{{detailsrow.notes}}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="附件信息">
							<div class="view_path" @click="previewFile(item)"
								v-for="(item, index) in detailsrow['attPaths']" :key="index">
								{{ item.name }}
							</div>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="物品图片">
							<div class="view_path_img" v-for="(item, index) in detailsrow.picPathList" :key="index"
								style="display: flex; justify-content: space-between">
								<div class="view_path_img_margin"></div>
								<div class="view_path_img_center">
									<img :src="pyapi_url + item" @click="show_img(index, detailsrow.picPaths)" />
								</div>
							</div>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>

					<a-col :span="12">
						<a-form-model-item label="证书信息">
							<div class="view_path" @click="previewFile(item)"
								v-for="(item, index) in detailsrow.certPaths" :key="index">
								{{ item.name }}
							</div>
						</a-form-model-item>
					</a-col>
				</a-row>
			</a-form-model>
			<a-form-model :model="detailsrow" :labelCol="labelCol" :wrapperCol="wrapperCol"
				v-if="detailsrow.itemType==2">
				
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="归属公司">
							<span>{{detailsrow.companyName}}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="所属部门">
							<span>{{detailsrow.deptName}}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="物品类型">
							<span>{{detailsrow.itemType == 1? '固定资产':'流动资产'}}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="出库类型">
							<span>{{detailsrow.transTypeName}}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="资产类别">
							<span>{{detailsrow.spuTypeName}}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="物品编号">
							<span>{{detailsrow.spuSn}}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="物品名称">
							<span>{{detailsrow.name}}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="规格型号">
							<span>{{detailsrow.model}}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="是否已检定">
							<span>{{instrumentMap[detailsrow.isInspected]}}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="采购均价">
							<span>{{detailsrow.price}}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="原有库存">
							<span>{{detailsrow.spuAmount}}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="出库数量">
							<span>{{detailsrow.amount}}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
					<a-col :span="12">
						<a-form-model-item label="物品单位">
							<span>{{detailsrow.unit}}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="出库人">
							<span>{{detailsrow.operator}}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>

					<a-col :span="12">
						<a-form-model-item label="出库时间">
							<span>{{detailsrow.createTime}}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="备注">
							<span>{{detailsrow.notes}}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>

					<a-col :span="12">
						<a-form-model-item label="领用人">
							<span>{{detailsrow.applier}}</span>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="是否为制毒、制爆">
							<span>{{ detailsrow.hazardType ? detailsrow.hazardType.replace('其他;', '').replace(/;/g, '、') : '' }}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>

					<a-col :span="12">
						<a-form-model-item label="存放条件">
							<span>{{ detailsrow.storageCond ? detailsrow.storageCond.replace('其他;', '').replace(/;/g, '、') : '' }}</span>
						</a-form-model-item>
					</a-col>
				</a-row>
			</a-form-model>
		</a-modal>
		<preview ref="preview" />
	</div>
</template>

<script>

import {tree_all, enableParent} from '@/api/purchase'
	import {
		// transcation_get_list,
		// get_dept_tree,
		get_transcation_xlsx,
		// asset_transcation_get,
		assetTranscation,
		assetDeatil
	} from '@/api/assetmenag'
	import {
		checkPermission
	} from '@/utils/permissions'
	import {
		ACCESS_TOKEN
	} from '@/store/mutation-types'
	import storage from 'store'
	import preview from '@/components/module/prview'
import Tree from '@/components/Tree/Tree'
	export default {
		data() {
			return {
				colors1: {
					'3': '#F59A23',
					'4': '#69B839',
					'5': '#7F7F7F',
					'6': '#8400FF',
					'8': '#D9001B'
				},
				scroll_y: 150,
				companyMap: {},
				companylist: [],
				pagination: {
					current: 1,
					pageSize: 10,
					total: 0,
					pageSizeOptions: ['10', '20', '30', '40', '50'],
					showLessItems: true,
					showSizeChanger: true,
				},
				types: {
					'34586': '全部类型',
					'3': '直接出库',
					'4': '领用出库',
					'5': '报废出库',
					'6': '退货出库',
					'8': '盘亏出库',

				},
				deptTree: [],
                companyList: [], 
				deptData: [],
				deptList: [],
				departList: [],
				dataList: [],    
				serchInfo: {
					name: '',
					spu_sn: '',
					time: [],
					trans_type: 34586,
					item_type: undefined,
					company_id: undefined,
					dept_id: undefined,
					applier: '',
				},
				loading: false,
				data: '',
				visible: false,
				labelCol: {
					span: 7,
				},
				wrapperCol: {
					span: 17,
				},
				detailsrow: {},
				assetsExportConsumables: checkPermission('assetmenag:consumables:assetsExport'),
			}
		},
		components: {
			preview
		},
		created() {
			// tree_all().then(res => {
			// 	this.dataList = res.data[0]
			// })
				enableParent().then(res => {
				var arry = []
				var array1 = {}
				var data = []
				var data1 = {}
				res.rows.forEach(item => {
					if(item.isCompany == 1) {
						console.log(arry, 'arry=======================')
						if(arry.length != 0) {
							arry.forEach(item1 => {
							if(item1.deptId != item.deptId) {
								array1 = {
							         deptId: item.deptId,
							         title: item.deptName
					          	}
							}

						})
						 arry.push(array1)
						}else {
						array1 = {
							         deptId: item.deptId,
							         title: item.deptName
					          	}
						arry.push(array1)
							console.log(arry, 'arry=======================')

					}
						
					} else if(item.isCompany == 0) {
						if(data.length != 0) {
							data.forEach(item1 => {
							if(item1.deptId != item.deptId) {
								data1 = {
							         deptId: item.deptId,
							         title: item.deptName,
									 parentId: item.parentId
					          	}
							}

						})
						 data.push(data1)
						}else {
						data1 = {
							         deptId: item.deptId,
							         title: item.deptName,
									  parentId: item.parentId
					          	}
						data.push(data1)
					}
					}
				})
				this.companyList = arry
				this.deptData = data
			})








			// tree_all
			// enableParent().then(res => {
			// 	var arry = []
			// 	var array1 = {}
			// 	res.rows.forEach(item => {
			// 		console.log(item, 'item==========================')
			// 			if(item.isCompany == 1) {
			// 			if(arry.length != 0) {
			// 				arry.forEach(item1 => {
			// 				if(item1.deptId != item.deptId) {
			// 					array1 = {
			// 				         deptId: item.deptId,
			// 				         title: item.deptName
			// 		          	}
			// 				}
			// 			})
			// 			 arry.push(array1)
			// 			}else {
			// 			array1 = {
			// 				         deptId: item.deptId,
			// 				         title: item.deptName
			// 		          	}
			// 			arry.push(array1)
			// 		}
			// 		}
			// 	})
			// 		this.companyList = arry
			// })
			// get_dept_tree().then((res) => {
			// 	this.companylist = res.data.dept_lis
			// 	this.companylist.unshift({
			// 		dept_id: 0,
			// 		dept_name: '所有公司',
			// 		child_lis: [],
			// 	})
			// 	this.companylist.map((d) => {
			// 		this.companyMap[d.dept_id] = {
			// 			text: d.dept_name,
			// 		}
			// 	})
			// })
		},
		mounted() {
			this.get_list()
			this.$nextTick(() => {
				var max_h = $('#content_main_center_scroll').height()
				setTimeout(() => {
					this.scroll_y = max_h - $('.ant-table-header').height() - 80
				}, 1000)
			})
		},
		methods: {
			changeDept(e) {
				this.deptList = []
				this.serchInfo.dept_id = undefined
					 this.deptData.forEach(item => {
						 if(item.parentId == e) {
							 this.deptList.push(item)
						 }
					 })
				// this.dataList.forEach(item => {
				// 	if(item.deptId == e) {
				// 		this.deptTree = item.children
				// 	}
				// })
			},
			show_img(idx, imgs) {
				var row = {
					index: idx,
					imgs: imgs,
				}
				this.$refs.preview.show(row)
			},
			//预览文件
			previewFile(file) {
				console.log(file)
				window.open('https://coa.anliantest.com/oaProxyApi/proxyPython/file/download?path=' + file.response.data)
			},
			details(row) {
				// if(row.trans_type_name=='领用出库'){
				// 	this.detailsrow =row
				// }else{
				// asset_transcation_get
				assetDeatil({
					id: row.id
				}).then(res => {
					if(res.code == 200) {
						Object.assign(res.data,{
						itemType:  row.itemType
					})
					this.detailsrow = res.data
					// this.detailsrow['purchasePrice'] = this.detailsrow['purchasePrice'] / 100
					// this.detailsrow['value'] = this.detailsrow['value'] / 100
					// this.detailsrow['amount'] = this.detailsrow['amount'] / 100
					// this.detailsrow['price'] = this.detailsrow['price'] / 100
					this.detailsrow['spuAmount'] = this.detailsrow['spuAmount'] == null ? null : this.detailsrow[
							'spuAmount']
					var att_paths = []
					var cert_paths = []
					console.log(this.detailsrow['attPath'])
					if (this.detailsrow['attPath']) {
						var as = this.detailsrow['attPath'].split(';')
						as.forEach((item) => {
							att_paths.push({
								name: item.split(',')[1],
								response: {
									data: item.split(',')[0],
								},
							})
						})
					}
					if (this.detailsrow['certPath']) {
						var as = this.detailsrow['certPath'].split(';')
						as.forEach((item) => {
							cert_paths.push({
								name: item.split(',')[1],
								response: {
									data: item.split(',')[0],
								},
							})
						})
					}
					this.detailsrow['attPaths'] = att_paths
					this.detailsrow['certPaths'] = cert_paths
					this.detailsrow['picPaths'] = this.detailsrow['picPath'] ? this.detailsrow['picPath'].split(
						';') : []
						this.visible = true
					} else {
						this.$message.error(res.msg)
					}
					
				})
				// }
				
			},
			//搜索
			handleSubmitSerch() {
				this.loading = true
				this.pagination.current = 1
				this.get_list()
			},
			get_list() {
				let user_info = this.$store.state.user.info.deptId
				if(!this.serchInfo.trans_type){
					this.serchInfo.trans_type = 34586
				}
				// let deptId = user_info.deptId
				assetTranscation({
					// transType: 3458,
					sortField: 'createTime',
					sortOrder: 'desc',
					name: this.serchInfo.name,
					itemType: this.serchInfo.item_type,
					itemSn: this.serchInfo.spu_sn,
					transType: this.serchInfo.trans_type,
					startDate: this.serchInfo.time.length ? this.serchInfo.time[0] : '',
					endDate: this.serchInfo.time.length ? this.serchInfo.time[1] : '',
					pageIndex: this.pagination.current,
					pageSize: this.pagination.pageSize,
					deptId: this.serchInfo.dept_id,
					companyId: this.serchInfo.company_id,
					applier: this.serchInfo.applier

				}).then((res) => {
					var lis = res.data.list
					lis.forEach((element) => {
						// element['amount'] = element['amount'] / 100
						element['spu_amount'] = element['spu_amount'] == null ? null : element[
							'spu_amount']
					})
					this.data = lis
					console.log(this.data, 'this.data===============================')
					this.loading = false
					const pagination = {
						...this.pagination
					}
					pagination.total = res.data.totalCount
					this.pagination = pagination
				})
				// transcation_get_list({
				// 	name: this.serchInfo.name,
				// 	item_type: this.serchInfo.item_type,
				// 	item_sn: this.serchInfo.spu_sn,
				// 	trans_type: this.serchInfo.trans_type,
				// 	start_date: this.serchInfo.time.length ? this.serchInfo.time[0] : '',
				// 	end_date: this.serchInfo.time.length ? this.serchInfo.time[1] : '',
				// 	page_num: this.pagination.current,
				// 	page_size: this.pagination.pageSize,
				// 	dept_id: deptId,
				// }).then((res) => {
				// 	var lis = res.data.items
				// 	lis.forEach((element) => {
				// 		element['amount'] = element['amount'] / 100
				// 		element['spu_amount'] = element['spu_amount'] == null ? null : element[
				// 			'spu_amount'] / 100
				// 	})
				// 	this.data = lis
				// 	console.log(this.data, 'this.data===============================')
				// 	this.loading = false
				// 	const pagination = {
				// 		...this.pagination
				// 	}
				// 	pagination.total = res.data.total
				// 	this.pagination = pagination
				// })
			},
			//改变分页
			handleTableChange(pagination, filters, sorter) {
				this.pagination.current = pagination.current
				this.pagination.pageSize = pagination.pageSize
				this.loading = true
				this.get_list()
			},
			exp() {
				let user_info = this.$store.state.user.info.deptId
				let deptId = user_info.deptId
				get_transcation_xlsx({
					name: this.serchInfo.name,
					item_type: this.serchInfo.item_type,
					item_sn: this.serchInfo.spu_sn,
					trans_type: this.serchInfo.trans_type,
					start_date: this.serchInfo.time.length ? this.serchInfo.time[0] : '',
					end_date: this.serchInfo.time.length ? this.serchInfo.time[1] : '',
					page_num: 1,
					page_size: 99999,
					dept_id: deptId,
					excel: 1,
				})
				// assetget_list2({
				// 	excel: 1
				// }).then(res => {
				// 	console.log(res)
				// })
			},
			//重置
			rester() {
				this.serchInfo = {
					name: '',
					spu_sn: '',
					time: [],
					item_type: undefined,
					trans_type: 34586,
					dept_id: undefined
				}
			},
		},
	}
</script>

<style scoped lang='less'>
</style>
